// Libraries
import { Button } from "@material-ui/core";
import classNames from "classnames";
import { useObserver } from "mobx-react-lite";
import React from "react";

// Core
import { isEmptyOrWhitespace } from "../../../../Core/Utils/Utils";

// Custom
import { BQSButtonStyle } from "./../BQSPrimitivesStyle";
import { isNullOrUndefined } from "Custom/Utils/Utils";

interface IProps {
    className?: string;
    displayName: string;
    execute: () => void;
    canExecute?: boolean;
    isSubmit?: boolean;
    startIcon?: React.ReactNode;
}

export const BQSButton: React.FC<IProps> = (props: IProps) => {
    // #region Code Behind

    const buttonClasses = BQSButtonStyle();

    const getClassName = (): string => {
        return classNames({
            BQSButton: true,
            [`${props.className}`]: !isEmptyOrWhitespace(props.className),
        });
    };

    const getType = (): "button" | "submit" | "reset" => {
        return !isNullOrUndefined(props.isSubmit) && props.isSubmit ? "submit" : "button";
    };

    const isDisabled = (): boolean => {
        return !isNullOrUndefined(props.canExecute) ? !props.canExecute : false;
    };

    const onClick = (event: React.MouseEvent<HTMLButtonElement>): void => {
        props.execute();

        if (!isNullOrUndefined(props.isSubmit) && props.isSubmit) {
            event.preventDefault();
        }
    };

    // #endregion Code Behind

    // #region Render Result

    return useObserver(() => (
        <Button classes={buttonClasses} className={getClassName()} disabled={isDisabled()} onClick={onClick} startIcon={props.startIcon} type={getType()}>
            {props.displayName}
        </Button>
    ));

    // #endregion Render Result
};
